import ReactDOM from 'react-dom';
import React from 'react';
import { AppContainer } from 'react-hot-loader';
import Root from 'data/common/Root';

const render = Component => {
    ReactDOM.render(
        <AppContainer>
            <Component />
        </AppContainer>,
        document.getElementById('root')
    );
};

render(Root);

// Webpack Hot Module Replacement API
if (module.hot) {
    module.hot.accept();
}



// WEBPACK FOOTER //
// ./index.js